import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Main from '../views/Main.vue';
import Shopping from '../views/Shopping.vue';
import FunLearn from '../views/FunLearn.vue';
import About from '../views/About.vue';
import Beauty from '../views/Beauty.vue';
import GameOpening from '../views/GameOpening.vue';
import Game from '../views/Game.vue';
import Selfie from '../views/Selfie.vue';
import Camera from '../views/Camera.vue';
import Testimoni from '../views/Testimoni.vue';

declare const process: any;

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/main-stage',
    name: 'main',
    component: Main,
  },
  {
    path: '/nutrilite-shopping',
    name: 'shooping',
    component: Shopping,
  },
  {
    path: '/fun-and-learn',
    name: 'funAndLearn',
    component: FunLearn,
  },
  {
    path: '/fun-and-learn/tentang-nutrilite-mixed-collagen-drink',
    name: 'about',
    component: About,
  },
  {
    path: '/fun-and-learn/in-out-beauty',
    name: 'beauty',
    component: Beauty,
  },
  {
    path: '/fun-and-learn/kata-mereka',
    name: 'kata-mereka',
    component: Testimoni,
  },
  {
    path: '/fun-and-learn/show-your-smile',
    name: 'selfie',
    component: Selfie,
  },
  {
    path: '/fun-and-learn/show-your-smile/camera',
    name: 'camera',
    component: Camera,
  },
  {
    path: '/fun-and-learn/game/:game',
    name: 'game-opening',
    component: GameOpening,
  },
  {
    path: '/fun-and-learn/game/:game/play',
    name: 'game',
    component: Game,
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const { app }: any = router;
  next();
});

export default router;
